export default __webpack_public_path__ + "static/media/forest_mint.0a7a163a.png";